import { HTMLSpocUIProps } from "@/types";
import { TextAreaVariantProps } from "./TextArea.style";
import {
  controlClasses,
  errorClasses,
  fieldWrapperClasses,
  helpTextClasses,
  labelClasses,
  rootClasses,
} from "@/Field/Field.style";
import { useCallback, useState } from "react";
import words from "lodash/words";
import capitalize from "lodash/capitalize";
import { Field } from "@base-ui-components/react/field";

export type TextAreaProps = TextAreaVariantProps &
  HTMLSpocUIProps<"textarea"> & {
    label?: string;
    helpText?: string;
    error?: string;
  };

const TextArea = (props: TextAreaProps) => {
  const {
    fullWidth,
    maxLength,
    onChange,
    helpText,
    label,
    required,
    colSpan,
    name,
    id,
    className,
    rows = 2,
    error,
    ...rest
  } = props;
  const [text, setText] = useState("");

  const handleChange = (e: any) => {
    if (maxLength) {
      setText(e.target.value);
    }
    if (typeof onChange === "function") {
      onChange(e);
    }
  };

  const capitalizeName = capitalize(words(name).join(" "));

  const handleCustomError = useCallback(() => {
    if (error) {
      return error;
    }
    return [];
  }, [error]);

  return (
    <Field.Root
      validate={error ? handleCustomError : undefined}
      className={rootClasses({ colSpan, className: className })}
      validationMode="onChange"
      name={name}
    >
      {(label || capitalizeName) && (
        <Field.Label className={labelClasses({ required })}>
          {label || capitalizeName}
        </Field.Label>
      )}
      <div className={fieldWrapperClasses({})}>
        <Field.Control
          onChange={handleChange}
          required={required}
          render={(props) => (
            <textarea
              rows={rows}
              maxLength={maxLength}
              {...props}
              {...rest}
              onChange={props.onChange}
            />
          )}
          className={controlClasses({
            hasStartAdornment: false,
            className: "h-auto py-2",
          })}
        />
      </div>
      <Field.Error className={errorClasses({})} />
      {helpText && (
        <Field.Description className={helpTextClasses({})}>
          {helpText}
        </Field.Description>
      )}
      {maxLength && (
        <p className="self-end">
          {text.length}/{maxLength}
        </p>
      )}
    </Field.Root>
  );
};

export default TextArea;
